import React from 'react';
import { Box, keyframes } from '@mui/material';

// Animations
const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

interface PageTransitionProps {
  children: React.ReactNode;
  delay?: number; // Delay in ms
  duration?: number; // Duration in ms
  type?: 'slide' | 'fade';
}

export const PageTransition: React.FC<PageTransitionProps> = ({ 
  children, 
  delay = 0, 
  duration = 500,
  type = 'slide'
}) => {
  return (
    <Box
      sx={{
        animation: type === 'slide' 
          ? `${fadeSlideUp} ${duration}ms ease-out ${delay}ms both`
          : `${fadeIn} ${duration}ms ease-out ${delay}ms both`,
      }}
    >
      {children}
    </Box>
  );
};

// Component for staggered grid/list items
interface StaggeredItemProps {
  children: React.ReactNode;
  index: number;
  baseDelay?: number; // Base delay in ms
  staggerDelay?: number; // Delay between items in ms
}

export const StaggeredItem: React.FC<StaggeredItemProps> = ({
  children,
  index,
  baseDelay = 0,
  staggerDelay = 50,
}) => {
  return (
    <Box
      sx={{
        animation: `${fadeSlideUp} 0.5s ease-out ${baseDelay + index * staggerDelay}ms both`,
      }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;

